import React from 'react'

const UploadFile = () => {
  return (
    <div>UploadFile</div>
  )
}

export default UploadFile